//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vueFilter from "@/common/filter/vuefilter.js";
import { setTimeout } from "timers";
import { getCookie } from 'tiny-cookie';
// import { iDatePicker } from '@/icomponents';
import dateControl from '@/icomponents/iDatePicker/dateControl';
export default {
  name: "index",
  extends: dateControl,
  components: {
    // iDatePicker
  },
  data() {
    return {
      isShowPop: false,
      columns: [],
      workerTypeList: [],
      budgetItemList: [],
      popType: "",
      isShowTimePop: false,
      currentDate: new Date(),
      target: "",
      formData: {
        itsItemData: {
          budgetItem: "",
          workerType: ""
        },
        itemName: "上会人员",
        dtStart: "",
        dtEnd: "",
        days: "",
        number: "",
        descr: "",
        amount: "",
        price: 0.0,
        ItemId: this.$route.query.ItemId,
        proposalId: this.iStorage.get('eventData').proposalId
      },
      popTitle: "",
      tenant: this.iStorage.get("eventData").tenant_code,
      minDate: new Date(),
      tenantCode: JSON.parse(getCookie('eventData')).tenant_code
    };
  },
  watch: {
    "formData.number"() {
      this.formData.amount =
        this.formData.price * this.formData.number * this.formData.days;
    },
    "formData.days"() {
      this.formData.amount =
        this.formData.price * this.formData.number * this.formData.days;
    },
    "formData.price"() {
      this.formData.amount =
        this.formData.price * this.formData.number * this.formData.days;
    },
     "formData.dtStart"() {
       let startDay=new Date(this.formData.dtStart);
       let endDay=new Date(this.formData.dtEnd);
       this.formData.days=(endDay-startDay)/(1000 * 60 * 60 * 24)+1;
       if (this.formData.days < 1) {
        this.$toast("天数不能小于1");
        return;
      }

    },
     "formData.dtEnd"() {
      let startDay=new Date(this.formData.dtStart);
       let endDay=new Date(this.formData.dtEnd);
       this.formData.days=(endDay-startDay)/(1000 * 60 * 60 * 24)+1;
       if (this.formData.days < 1) {
        this.$toast("天数不能小于1");
        return;
      }
    },
  },
  created() {
    let SaveMode = this.$route.query.SaveMode;
    if (SaveMode == 1) {
      this.getInitData();
    }
    this.getBudgetItemList();
    this.getWorkerTypeList();
    this.setRouteListeners("editDemandGoBack");
    this.$root.$eventHub.$on("editDemandGoBack", data => {
      this.editDemandGoBack();
      this.$root.$eventHub.$off("editDemandGoBack"); //解绑当前监听，否则下轮监听还会持续叠加
    });
  },
  methods: {
    editDemandGoBack() {
      this.removeRouteListeners("editDemandGoBack");
      this.$router.push({
        path: "/"
      });
    },
    async getInitData() {
      let params = {
        Filters: {
          ItemId: this.$route.query.ItemId
        }
      };
      const res = await this.axios.post(this.api.GetItem, params);
      if (res.success) {
        this.formData.itsItemData.budgetItem =
          res.content.itsItemData.budgetItem;
        this.formData.itsItemData.workerType =
          res.content.itsItemData.workerType;
        this.formData.dtStart = vueFilter.formatDate(
          res.content.dtStart,
          "yyyy-MM-dd"
        );
        this.formData.dtEnd = vueFilter.formatDate(
          res.content.dtEnd,
          "yyyy-MM-dd"
        );
        this.formData.days = res.content.days;
        this.formData.number = res.content.number;
        this.formData.descr = res.content.descr;
        this.formData.amount = res.content.amount;
        this.formData.price = res.content.price;
      }
    },
    //返回
    onClickLeft() {
      this.$router.back();
    },
    //保存
    save() {
      if (
        !this.formData.itsItemData.budgetItem ||
        !this.formData.itsItemData.workerType ||
        !this.formData.dtStart ||
        !this.formData.dtEnd ||
        !this.formData.days ||
        !this.formData.number
      ) {
        this.$toast("必填选项不能为空!");
        return;
      }
      if(this.tenantCode == 'lilly') {
        this.dateIsAble(this.formData.dtStart, 3).then(res => {
          if(res) {
            this.$toast("请提前3个工作日提交需求！");
          }else{
            this.onClickRight();
          }
        });
      }else {
        this.onClickRight();
      }
    },
    async onClickRight() {
      if (this.formData.days < 1) {
        this.$toast("天数不能小于1");
        return;
      }
      if (this.formData.number < 1) {
        this.$toast("人数不能小于1");
        return;
      }
      this.$dialog
        .confirm({
          title: "再次确认",
          message: "您是否确认保存?"
        })
        .then(async () => {
          let params = {
            SaveMode: this.$route.query.SaveMode,
            EntityDto: this.formData
          };
          const res = await this.axios.post(this.api.Save, params);
          if (res.success) {
            this.$toast("保存成功");
            setTimeout(() => {
              this.$router.back();
            }, 1000);
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    // 下拉框选择
    onConfirm(value, index) {
      if (this.popType == "预算项目") {
        this.formData.itsItemData.budgetItem = value;
      } else {
        this.formData.itsItemData.workerType = value;
        this.formData.price = this.workerTypeList[index].val;
      }

      this.isShowPop = false;
    },
    // 取消
    onCancel() {
      this.isShowPop = false;
    },
    async getBudgetItemList() {
      let res = await this.axios.post(this.api.GetBudgetProject);
      if (res.success) {
        this.budgetItemList = res.content;
        this.formData.itsItemData.budgetItem=this.budgetItemList[0].txt;
      }
    },
    async getWorkerTypeList() {
      let res = await this.axios.post(this.api.GetWorkerTypes);
      if (res.success) {
        this.workerTypeList = res.content;
      }
    },
    showPop(type) {
      if (type == "预算项目") {
        this.popTitle = "选择预算项目";
        let arr = [];
        this.budgetItemList.forEach((item, index) => {
          arr.push(item.txt);
        });
        this.columns = arr;
      } else if (type == "人员类型") {
        this.popTitle = "选择人员类型";
        let arr = [];
        this.workerTypeList.forEach((item, index) => {
          arr.push(item.txt);
        });
        this.columns = arr;
      }
      this.isShowPop = true;
      this.popType = type;
    },
    selectDate(dataItem) {
      if(dataItem == 'dtEnd' && !this.formData.dtStart) {
        this.$toast("请先选择开始时间！");
        return;
      }
      if (dataItem == "dtStart") {
        this.minDate = new Date();
      } else {
        this.minDate = this.formData.dtStart ? new Date(this.formData.dtStart) : new Date();
      }
      this.target = dataItem;
      this.isShowTimePop = true;
      // if(tenantCode == 'lilly') {
      //   this.$refs.iDatePicker.getDateConfig();
      // }else {
      //   this.isShowTimePop = true;
      // }
    },
    callback(date) {
      console.log(date);
      this.currentDate = date;
      this.handConfirm();
    },
    handConfirm() {
      if (this.target == "dtStart") {
        this.formData.dtStart = vueFilter.formatDate(
          this.currentDate,
          "yyyy-MM-dd"
        );
      } else {
        this.formData.dtEnd = vueFilter.formatDate(
          this.currentDate,
          "yyyy-MM-dd"
        );
      }
      this.isShowTimePop = false;
    },
    handCancel() {
      this.isShowTimePop = false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/editDemand.vue